import React from 'react';
import { func, string, bool } from 'prop-types';

const getPosition = (e, offset) => ({
  x: e.clientX - offset.x,
  y: e.clientY - offset.y,
});

const getRectangle = (e, anchor, offset) => {
  const pos = getPosition(e, offset);
  const width = pos.x - anchor.x;
  const height = pos.y - anchor.y;

  return {
    x: width < 0 ? pos.x : anchor.x,
    y: height < 0 ? pos.y : anchor.y,
    width: Math.abs(width),
    height: Math.abs(height),
  };
};

const initialState = {
  anchor: null,
  offset: null,
  top: null,
  left: 0,
  width: 0,
  height: 0,
};

class ImageRectangleDrawer extends React.Component {
  state = initialState;

  componentWillReceiveProps(nextProps) {
    if (this.props.imageUrl !== nextProps.imageUrl) {
      this.props.onReset();
      this.setState(initialState);
    }
  }

  handleMouseDown = e => {
    let elem = this.containerRef;
    const offset = { x: 0, y: 0 };
    if (elem.offsetParent) {
      do {
        offset.x += elem.offsetLeft;
        offset.y += elem.offsetTop;
      } while ((elem = elem.offsetParent));
    }

    const anchor = { x: e.clientX - offset.x, y: e.clientY - offset.y };

    this.setState({
      anchor,
      offset,
      top: e.clientY - offset.y,
      left: e.clientX - offset.x,
      width: 0,
      height: 0,
    });

    this.props.onReset();
  };

  handleMouseMove = e => {
    if (!this.state.anchor) return;
    const { anchor, offset } = this.state;

    const { x: left, y: top, width, height } = getRectangle(e, anchor, offset);

    this.setState({ left, top, width, height });
  };

  handleMouseUp = e => {
    const { anchor, offset } = this.state;
    this.setState({ anchor: null, offset: null });
    if (anchor && offset)
      this.props.onDraw({
        rectangle: getRectangle(e, anchor, offset),
        container: {
          width: this.containerRef.offsetWidth,
          height: this.containerRef.offsetHeight,
        },
      });
  };

  handleRef = elem => {
    if (elem) this.containerRef = elem;
  };

  render() {
    const { imageUrl, inTransition } = this.props;
    const { original } = imageUrl || {};

    return (
      <div
        className="image-rectangle-drawer-wrap"
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        onMouseUp={this.handleMouseUp}
        ref={this.handleRef}
        style={{ backgroundImage: `url('${original}')` }}
      >
        {this.state.top !== null && (
          <div
            style={{
              background: 'rgba(255,255,255,0.5)',
              border: 'solid 2px red',
              display: inTransition ? 'none' : 'block',
              position: 'absolute',
              ...this.state,
            }}
          ></div>
        )}
      </div>
    );
  }
}

ImageRectangleDrawer.propTypes = {
  imageUrl: string,
  inTransition: bool,
  onDraw: func,
  onReset: func,
};

export default ImageRectangleDrawer;
